
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/packages",
      function () {
        return require("private-next-pages/shop/packages.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/packages"])
      });
    }
  